<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>All-time top gainers</b-card-title>
    </b-card-header>
    <b-card-body>
      <template v-if="loading">
        <div
          v-for="i in 3"
          :key="i"
          class="employee-task d-flex justify-content-between align-items-center mt-2"
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <b-skeleton width="40px" height="40px" class="rounded-circle" />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                <b-skeleton width="100px" height="20px" />
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <b-skeleton width="80px" height="20px" />
          </div>
        </div>
      </template>
      <template v-else-if="topGainers.length">
        <div
          v-for="(topGainer, index) in topGainers"
          :key="index"
          class="employee-task d-flex justify-content-between align-items-center my-50"
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <b-avatar class="rounded-avatar" size="42" :src="topGainer.avatar" style="border: 2px solid #4D556D;" />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                {{ topGainer.full_name }}
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class=" font-weight-bolder text-info mr-75"
              >${{
                topGainer.net_profit ? topGainer.net_profit.toFixed(2) : 0
              }}</span
            >
          </div>
        </div>
      </template>
      <template v-else>
         <div
          class="d-flex align-items-center justify-content-center h-100  new-alert"
        >
          <b-alert
            show
            variant="secondary"
            class="d-flex align-items-center justify-content-center p-3 w-100"
          >
            no information
          </b-alert>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BMedia,
  BAvatar,
  BMediaBody,
  BMediaAside,
  BCardBody,
  BCardTitle,
  BCardHeader,
  BImg,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BMedia,
    BAvatar,
    BMediaBody,
    BMediaAside,
    BCardBody,
    BCardTitle,
    BCardHeader,
    BImg,
    BSkeleton,
    BAlert,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    analytics(val) {
      this.topGainers = val.top_gainer;
    },
  },
  data() {
    return {
      topGainers: [],
    };
  },
};
</script>

<style></style>
